// utils/redirectManager.ts
export const DEFAULT_REDIRECT = "/";

export const getRedirectParam = (search: string): string => {
  const params = new URLSearchParams(search);
  const raw = params.get("redirect");
  if (!raw) return DEFAULT_REDIRECT;

  try {
    return decodeURIComponent(decodeURIComponent(raw));
  } catch {
    return decodeURIComponent(raw);
  }
};

// ✅ Internal project route
export const isInternalDashboardRoute = (path: string) =>
  path.startsWith("/dashboard");

// ✅ Full URL from external app
export const isExternalUrl = (path: string) =>
  path.startsWith("http://") || path.startsWith("https://");

// Central redirect solver
export const doRedirect = (redirect: string, navigate: any) => {
  if (!redirect) redirect = DEFAULT_REDIRECT;

  if (isExternalUrl(redirect)) {
    console.log("redirect from windows", redirect);
    window.location.href = redirect; // 🔥 external redirect
  } else {
    console.log("redirect from navigate", redirect);
    navigate(redirect, { replace: true }); // 🔥 internal navigate()
  }
};
